import React, { useState } from "react";
import style from "../../Style.module.scss";
import StatusDot from "../../../../components/StatusDot/StatusDot";
import CircularProgress from "../../../../components/CircularProgress/CircularProgress";
import TrendPercent from "../../../../components/TrendPercent/TrendPercent";
import AlertDot from "../../../../components/AlertDot/AlertDot";
import ChildRow from "./ChildRow";
import moment from "moment";
import useMerchantStore from "../../../../stores/merchant";
import useCommonStore from "../../../../stores/common";
const PROCESSING_COLOR = "#37B450";
const NOT_PROCESSING_COLOR = "#BFBFC3";

function Row({ app }) {
  const showDetails = useCommonStore((state) => state.showDetails);
  const setShowDetails = useCommonStore((state) => state.setShowDetails);
  const setActiveApp = useMerchantStore((state) => state.setActiveApp);
  const activeApp = useMerchantStore((state) => state.activeApp);

  const [childAppOpen, setChildAppOpen] = useState(false);

  return (
    <>
      <tr
        onClick={() => {
          setActiveApp(app);
          setShowDetails(true);
        }}
        className={`${activeApp?.id == app.id ? style.active_app : ""}`}
      >
        <td>
          {/* <ButtonIcon onClick={(e) => { setChildAppOpen(!childAppOpen); e.stopPropagation(); }}>
            <CaretRight className={`${style.caret_icon} ${childAppOpen ? style.rotate_90 : ""}`} />
          </ButtonIcon> */}
        </td>
        <td>{app.field_dba}</td>
        <td>
          {app.power_app_submission ? (
            <StatusDot color={PROCESSING_COLOR} />
          ) : (
            <StatusDot color={NOT_PROCESSING_COLOR} />
          )}
        </td>
        {!showDetails && <td>$ -</td>}
        <td>
          <CircularProgress value={12} />
        </td>
        <td>$ 2,000</td>
        {!showDetails && (
          <td>
            <TrendPercent percent={-56} />
          </td>
        )}
        {!showDetails && (
          <td>
            {moment(app?.power_app_submission?.created_at)?.format(
              "MMM D, YYYY",
            )}
          </td>
        )}
        <td>
          <AlertDot />
        </td>
      </tr>
      {childAppOpen && <ChildRow />}
    </>
  );
}

export default Row;
